import { HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { StorageService } from '../services/storage/storage.service';

export const authInterceptor: HttpInterceptorFn = (req, next) => {
  const storageService = inject(StorageService);
  
  const isPublicEndpoint = 
    req.url.includes('/Auth/login') ||
    req.url.includes('/Auth/refreshtoken') ||
    req.url.includes('/Auth/easyaccess/login') ||
    req.url.includes('/Auth/password/recovery') ||
    req.url.includes('/Auth/easyaccess/recovery') ||
    req.url.includes('/Verification/') ||
    req.url.includes('/Onboarding/user/create') ||
    req.url.includes('ipify');

  if (isPublicEndpoint) {
    return next(req);
  }

  const token = storageService.getToken();

  if (token) {
    const clonedReq = req.clone({
      setHeaders: {
        Authorization: `Bearer ${token}`
      }
    });
    return next(clonedReq);
  }

  return next(req);
};
